import React from "react";
import PropTypes from "prop-types";
import BtnGreen from "../BtnGreen";

import "./style.scss";

const faqLink = `${window.location.origin}/about-green-homes/`;
const thankyouImage = `${window.location.origin}/wp-content/uploads/2021/09/thankyou.png`;

const ThankYou = (props) => {
  return (
    <div className="text-sgbc-black-800 text-center">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-28 font-semibold mb-4">Go You!</h2>

        <div className="thank-you-content text-lg space-y-5 mb-8">
          <p>
            Thank you for sharing your efforts to build green into your home and
            your neighbourhood! Your photo will be available in the gallery soon
            and be sure to share your entry on social media to rally votes for
            your home and ‘hood!
          </p>
          <p>
            Should your entry be shortlisted for a prize, we will send you an
            email to learn more about your entry and home
          </p>
          <p>In the meantime, you can learn more about Green Buildings!</p>
        </div>

        <a href={faqLink} target="_blank">
          <BtnGreen>About Green Buildings</BtnGreen>
        </a>
      </div>

      <div>
        <img
          className="ml-auto transform translate-y-20"
          src={thankyouImage}
          alt="image"
        />
      </div>
    </div>
  );
};

ThankYou.propTypes = {};

export default ThankYou;
